import { Anulicense } from "../license";

const OurWork = () => {
  const images = [
    Anulicense.ourWork1,
    Anulicense.ourWork2,
    Anulicense.ourWork3,
    Anulicense.ourWork4,
    Anulicense.ourWork5,
    Anulicense.ourWork6,
    Anulicense.ourWork7,
    Anulicense.ourWork8,
    Anulicense.ourWork9,
    Anulicense.ourWork10
  ];

  return (
    <section>
      <div className="container pb-40 mx-auto">
        <div className="container mx-auto px-10 pt-40">
          <div className="flex justify-center mb-20 ">
            <div className="w-[60%] z-10 text-center relative">
              <h4 className="lg:text-[24px] xl:text-[24px] md:text-[24px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] text-[18px] leading-[30px] font-secondary_font font-bold text-[#aa8210]">
                Our Recent Works
              </h4>
              <h2 className="lg:text-[50px] xl:text-[50px] md:text-[50px] text-[28px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] leading-[35px] font-medium">
                Let’s See Our Latest Project That Recently Done
              </h2>
              <span className="font-secondary_font top-[70%] lg:text-[140px] xl:text-[140px] md:text-[140px] text-[80px] shadow-text">
                Work
              </span>
            </div>
          </div>
        </div>
        <div className="lg:mx-10 xl:mx-10">
          <div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 p-4">
              {images.map((src, index) => {
                const isEvenCol = index % 2 === 0;
                const isEvenRow = Math.floor(index / 5) % 2 === 0;
                const isMediumHeight =
                  (isEvenCol && !isEvenRow) || (!isEvenCol && isEvenRow);
                const heightClass = isMediumHeight
                  ? "h-40 sm:h-48"
                  : "h-60 sm:h-72";

                return (
                  <img
                    key={index}
                    src={src}
                    alt={`img-${index}`}
                    className={`w-full ${heightClass} object-cover rounded-lg shadow-md hover:scale-105 transition-transform duration-300`}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurWork;
